import { ReactElement } from "react";
import { ListTableColumn, renderEnumValue } from "sprint-common-web";

import { MuxerType } from "../types/MuxerType";

export const renderMuxerType = <T,>(item?: T, _index?: number, column?: ListTableColumn<T>): ReactElement | null => {
    return renderEnumValue(MuxerType, item, _index, column);
};
